var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppDimension({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2373 14.4297C22.4155 14.4297 28.373 18.4629 28.373 26.4924C28.373 34.1521 22.5635 39.2214 15.0518 39.2214H5.35742V14.4297H15.2373ZM12.2398 33.3381H15.5703C18.6782 33.3381 20.9356 30.8218 20.9356 26.7515C20.9356 22.3113 18.8262 20.3132 15.3477 20.3132H12.2398V33.3381Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9941 21.4602C33.4736 20.3872 36.7295 19.573 40.2822 19.573C45.9434 19.573 48.9775 22.3852 48.9775 27.6025V39.2214H42.502V27.9726C42.502 25.9006 41.688 24.8274 39.6528 24.8274C38.7647 24.8274 38.1357 24.9385 37.4697 25.2344V39.2214H30.9941L30.9941 21.4602Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppDimension);
export default __webpack_public_path__ + "static/media/B_app_Dimension.253efcf31eda958f16f7ea5b30724f37.svg";
export { ForwardRef as ReactComponent };